import http from "@/settings/apiSettings"

class PORTAL_TicheteService {
  private authHeader() {
    return { headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") } };
  }

  getTipuri(): Promise<any> {
    return http.clientPortalHR.get("/portal/tichete/tipuri", this.authHeader());
  }

  getZileLucratoare(di: string, df: string): Promise<any> {
    return http.clientPortalHR.get("/portal/tichete/zile-lucratoare", {
      params: { di, df },
      ...this.authHeader(),
    });
  }

  creeaza(payload: { TipID: number; PentruAngajatID?: string | null; Proprietati: { DictionarID: number; Valoare: string }[] }): Promise<any> {
    return http.clientPortalHR.post("/portal/tichete", payload, this.authHeader());
  }
}

export default new PORTAL_TicheteService();
